import { Box } from '@mui/material';

const CustomDivider = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        height: '4px', // Height of the divider
        width: '100%', // Width of the divider
      }}
    >
      <Box sx={{ width: '33.33%', bgcolor: 'white' }} />
      <Box sx={{ width: '33.33%', bgcolor: '#FFC000' }} />
      <Box sx={{ width: '33.33%', bgcolor: '#4EA72E' }} />
    </Box>
  );
};

export default CustomDivider;
